
import { ExternalLinkIcon } from "@heroicons/react/outline";
import { MIMETYPE_ICON_MAP } from "../utils";

interface Props {
  name: string
  mimetype: string;
  url: string;
  status: string;
  timestamp?: string;
}

function WorkflowOutputsItemFile(props: Props) {
  return (
    <div className="flex items-center">
      <img className="w-4 h-4 mr-2" src={MIMETYPE_ICON_MAP[props.mimetype ?? "application/vnd.google-apps.document"]} alt="Output file icon" />
      <a className="group hover:underline hover:text-blue" href={props.url} target="_blank" rel="noreferrer">
        {props.name}<ExternalLinkIcon className="hidden group-hover:inline-block w-4 h-4 ml-1 text-blue" />
      </a>
      <div className="text-sm text-center font-semibold text-green w-40 ml-auto">
        {props.status}
      </div>
      <div className="w-40 mr-2">
        {props.timestamp}
      </div>
    </div>
  );
}

export default WorkflowOutputsItemFile;
